export default "__VITE_ASSET__e521fa38__"